import moment from 'moment';
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

// حالات الفترة
const PERIOD_DRAFT = 1;
const PERIOD_ACTIVE = 2;
const PERIOD_CLOSED = 3;

// حالات المجموعة
const GROUP_PENDING = 1;
const GROUP_OPEN = 2;
const GROUP_APPROVED = 3;

// حالات العضوية
const MEMBER_ACTIVE = 1;
const MEMBER_EXCLUDED = 2;

export default {
    name: 'InventoryCountPeriods',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewPage) {
            this.$helper.ShowMessage('error', 'غير مصرح', 'إدارة فترات الجرد متاحة لإدارة الصيدلة والوزارة فقط.');
            this.href('/Home');
            return;
        }
        this.GetInfo(1);
    },

    computed: {
        canViewPage() {
            return !!(this.loginDetails && this.hasInventoryAndStockAccessUi());
        },
        selectedGroupsForMove() {
            if (!this.selectedPeriod) return [];
            return (this.selectedPeriod.groups || []).filter(
                (g) => g.id !== this.excludeForm.groupId && g.status !== GROUP_APPROVED
            );
        },
        unassignedBranches() {
            return this.branchLookup.filter((b) => !b.assignedGroupId);
        },
    },

    filters: {
        moment(date) {
            if (!date) return '—';
            return moment(date).format('DD/MM/YYYY HH:mm');
        },
    },

    data() {
        return {
            filters: { pageNo: 1, pageSize: 25 },
            Info: [],
            pages: 0,

            selectedPeriod: null,
            loadingDetail: false,

            branchLookup: [],

            periodDialog: false,
            periodForm: { id: null, name: '', note: '' },
            periodRules: {
                name: [{ required: true, message: 'الرجاء إدخال اسم الفترة', trigger: 'blur' }],
            },

            assignDialog: false,
            assignForm: { groupId: null, groupName: '', branchIds: [] },

            excludeDialog: false,
            excludeForm: { groupId: null, branchesId: null, branchName: '', reason: '', moveToGroupId: null },
            excludeRules: {
                reason: [{ required: true, message: 'سبب الاستبعاد إلزامي', trigger: 'blur' }],
            },

            approveDialog: false,
            approveForm: { groupId: null, groupName: '', note: '' },
        };
    },

    methods: {
        // ─── تسميات وحالات ───────────────────────────────────────────────
        periodStatusLabel(s) {
            if (s === PERIOD_DRAFT) return 'مسودة';
            if (s === PERIOD_ACTIVE) return 'نشطة';
            if (s === PERIOD_CLOSED) return 'مغلقة';
            return '—';
        },
        periodStatusBadge(s) {
            if (s === PERIOD_ACTIVE) return 'primary';
            if (s === PERIOD_CLOSED) return 'secondary';
            return 'warning';
        },
        groupStatusLabel(s) {
            if (s === GROUP_PENDING) return 'بانتظار الدور';
            if (s === GROUP_OPEN) return 'مفتوحة للجرد';
            if (s === GROUP_APPROVED) return 'معتمدة';
            return '—';
        },
        groupStatusBadge(s) {
            if (s === GROUP_OPEN) return 'primary';
            if (s === GROUP_APPROVED) return 'success';
            return 'secondary';
        },
        branchStateLabel(m) {
            if (m.status === MEMBER_EXCLUDED) return 'مستبعد';
            const p = m.progress;
            if (!p) return '—';
            if (p.state === 'Completed') return 'مكتمل';
            if (p.state === 'AwaitingReview') return 'بانتظار المراجعة';
            if (p.state === 'InProgress') return 'قيد الجرد';
            if (p.state === 'NoStockings') return 'بلا مخازن';
            return 'لم يبدأ';
        },
        branchStateBadge(m) {
            if (m.status === MEMBER_EXCLUDED) return 'danger';
            const p = m.progress;
            if (!p) return 'secondary';
            if (p.state === 'Completed') return 'success';
            if (p.state === 'AwaitingReview' || p.state === 'InProgress') return 'warning';
            return 'secondary';
        },
        statusBadgeClass(badge) {
            return 'inventory-status-badge inventory-status-badge--' + (badge || 'secondary');
        },
        isGroupPending(g) { return g.status === GROUP_PENDING; },
        isGroupOpen(g) { return g.status === GROUP_OPEN; },
        isMemberActive(m) { return m.status === MEMBER_ACTIVE; },
        isPeriodClosed() {
            return this.selectedPeriod && this.selectedPeriod.status === PERIOD_CLOSED;
        },

        apiError(err, fallback) {
            const msg = err && err.response && err.response.data ? err.response.data : fallback;
            this.$helper.ShowMessage('error', 'خطأ', msg);
        },

        // ─── قائمة الفترات ───────────────────────────────────────────────
        GetInfo(pageNo) {
            this.filters.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetInventoryCountPeriods(this.filters.pageNo, this.filters.pageSize)
                .then((res) => {
                    this.$blockUI.Stop();
                    this.Info = (res && res.data && res.data.info) || [];
                    this.pages = (res && res.data && res.data.count) || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },

        // ─── تفاصيل فترة ─────────────────────────────────────────────────
        selectPeriod(row) {
            if (!row || !row.id) return;
            this.loadDetail(row.id);
        },

        loadDetail(id) {
            this.loadingDetail = true;
            this.$blockUI.Start();
            this.$http.GetInventoryCountPeriodById(id)
                .then((res) => {
                    this.$blockUI.Stop();
                    this.loadingDetail = false;
                    this.selectedPeriod = (res && res.data) || null;
                    this.loadBranchLookup(id);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.loadingDetail = false;
                    this.apiError(err, 'تعذّر تحميل تفاصيل الفترة.');
                });
        },

        backToList() {
            this.selectedPeriod = null;
            this.GetInfo(this.filters.pageNo);
        },

        refreshDetail() {
            if (this.selectedPeriod) this.loadDetail(this.selectedPeriod.id);
        },

        loadBranchLookup(periodId) {
            this.$http.GetInventoryCountPeriodBranches(periodId)
                .then((res) => { this.branchLookup = (res && res.data && res.data.info) || []; })
                .catch(() => { this.branchLookup = []; });
        },

        // ─── إنشاء/تعديل فترة ────────────────────────────────────────────
        openCreatePeriod() {
            this.periodForm = { id: null, name: '', note: '' };
            this.periodDialog = true;
        },

        openEditPeriod() {
            if (!this.selectedPeriod) return;
            this.periodForm = {
                id: this.selectedPeriod.id,
                name: this.selectedPeriod.name,
                note: this.selectedPeriod.note || '',
            };
            this.periodDialog = true;
        },

        submitPeriodForm() {
            this.$refs.periodForm.validate((valid) => {
                if (!valid) return;
                const payload = { Name: this.periodForm.name, Note: this.periodForm.note || null };
                const call = this.periodForm.id
                    ? this.$http.UpdateInventoryCountPeriod(this.periodForm.id, payload)
                    : this.$http.CreateInventoryCountPeriod(payload);

                this.$blockUI.Start();
                call.then((res) => {
                    this.$blockUI.Stop();
                    this.periodDialog = false;
                    const data = (res && res.data) || {};
                    this.$helper.ShowMessage('success', 'تم الحفظ', data.message || 'تم حفظ الفترة.');
                    if (this.periodForm.id) this.refreshDetail();
                    else if (data.id) this.loadDetail(data.id);
                    else this.GetInfo(1);
                }).catch((err) => {
                    this.$blockUI.Stop();
                    this.apiError(err, 'تعذّر حفظ الفترة.');
                });
            });
        },

        closePeriod() {
            if (!this.selectedPeriod) return;
            this.$confirm('سيتم إغلاق فترة الجرد نهائياً ولن يُسمح بفتح مجموعات جديدة فيها. متابعة؟', 'إغلاق الفترة', {
                confirmButtonText: 'إغلاق الفترة',
                cancelButtonText: 'تراجع',
                type: 'warning',
            }).then(() => {
                this.$blockUI.Start();
                this.$http.CloseInventoryCountPeriod(this.selectedPeriod.id)
                    .then((res) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم إغلاق الفترة.');
                        this.refreshDetail();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.apiError(err, 'تعذّر إغلاق الفترة.');
                    });
            }).catch(() => { });
        },

        // ─── المجموعات ───────────────────────────────────────────────────
        addGroup() {
            if (!this.selectedPeriod) return;
            this.$prompt('اسم المجموعة (اتركه فارغاً للتسمية التلقائية)', 'إضافة مجموعة', {
                confirmButtonText: 'إضافة',
                cancelButtonText: 'تراجع',
                inputPlaceholder: 'مثال: المجموعة الأولى — مستشفيات طرابلس',
            }).then(({ value }) => {
                this.$blockUI.Start();
                this.$http.AddInventoryCountPeriodGroup(this.selectedPeriod.id, { Name: value || null })
                    .then(() => {
                        this.$blockUI.Stop();
                        this.refreshDetail();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.apiError(err, 'تعذّر إضافة المجموعة.');
                    });
            }).catch(() => { });
        },

        renameGroup(group) {
            this.$prompt('اسم المجموعة', 'تعديل الاسم', {
                confirmButtonText: 'حفظ',
                cancelButtonText: 'تراجع',
                inputValue: group.name,
                inputValidator: (v) => (v && v.trim() ? true : 'الاسم مطلوب'),
            }).then(({ value }) => {
                this.$blockUI.Start();
                this.$http.UpdateInventoryCountPeriodGroup(group.id, { Name: value })
                    .then(() => {
                        this.$blockUI.Stop();
                        this.refreshDetail();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.apiError(err, 'تعذّر حفظ الاسم.');
                    });
            }).catch(() => { });
        },

        deleteGroup(group) {
            this.$confirm(`سيتم حذف «${group.name}» وإخلاء مرافقها. متابعة؟`, 'حذف مجموعة', {
                confirmButtonText: 'حذف',
                cancelButtonText: 'تراجع',
                type: 'warning',
            }).then(() => {
                this.$blockUI.Start();
                this.$http.DeleteInventoryCountPeriodGroup(group.id)
                    .then(() => {
                        this.$blockUI.Stop();
                        this.refreshDetail();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.apiError(err, 'تعذّر حذف المجموعة.');
                    });
            }).catch(() => { });
        },

        // ─── إسناد المرافق ───────────────────────────────────────────────
        openAssignDialog(group) {
            this.assignForm = { groupId: group.id, groupName: group.name, branchIds: [] };
            this.assignDialog = true;
        },

        submitAssignForm() {
            if (!this.assignForm.branchIds.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر مرفقاً واحداً على الأقل.');
                return;
            }
            this.$blockUI.Start();
            this.$http.AddInventoryCountPeriodGroupBranches(this.assignForm.groupId, { BranchIds: this.assignForm.branchIds })
                .then((res) => {
                    this.$blockUI.Stop();
                    this.assignDialog = false;
                    this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم الإسناد.');
                    this.refreshDetail();
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.apiError(err, 'تعذّر إسناد المرافق.');
                });
        },

        removeBranch(group, member) {
            this.$confirm(`إزالة «${member.branchName}» من «${group.name}»؟`, 'إزالة مرفق', {
                confirmButtonText: 'إزالة',
                cancelButtonText: 'تراجع',
                type: 'warning',
            }).then(() => {
                this.$blockUI.Start();
                this.$http.RemoveInventoryCountPeriodGroupBranch(group.id, { BranchesId: member.branchesId })
                    .then(() => {
                        this.$blockUI.Stop();
                        this.refreshDetail();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.apiError(err, 'تعذّرت الإزالة.');
                    });
            }).catch(() => { });
        },

        openExcludeDialog(group, member) {
            this.excludeForm = {
                groupId: group.id,
                branchesId: member.branchesId,
                branchName: member.branchName,
                reason: '',
                moveToGroupId: null,
            };
            this.excludeDialog = true;
        },

        submitExcludeForm() {
            this.$refs.excludeForm.validate((valid) => {
                if (!valid) return;
                this.$blockUI.Start();
                this.$http.ExcludeInventoryCountPeriodGroupBranch(this.excludeForm.groupId, {
                    BranchesId: this.excludeForm.branchesId,
                    Reason: this.excludeForm.reason,
                    MoveToGroupId: this.excludeForm.moveToGroupId || null,
                })
                    .then((res) => {
                        this.$blockUI.Stop();
                        this.excludeDialog = false;
                        this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم الاستبعاد.');
                        this.refreshDetail();
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.apiError(err, 'تعذّر الاستبعاد.');
                    });
            });
        },

        // ─── فتح واعتماد المجموعات ───────────────────────────────────────
        openGroup(group) {
            const activeCount = (group.branches || []).filter((m) => m.status === MEMBER_ACTIVE).length;
            this.$confirm(
                `سيتم فتح الجرد لمرافق «${group.name}» (${activeCount} مرفق) وإشعارها فوراً. متابعة؟`,
                'فتح الجرد للمجموعة',
                { confirmButtonText: 'فتح الجرد', cancelButtonText: 'تراجع', type: 'warning' }
            ).then(() => {
                this.callOpenGroup(group, null);
            }).catch(() => { });
        },

        callOpenGroup(group, exceptionalReason) {
            this.$blockUI.Start();
            this.$http.OpenInventoryCountPeriodGroup(group.id, { ExceptionalReason: exceptionalReason })
                .then((res) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', (res.data && res.data.message) || 'تم فتح المجموعة.');
                    this.refreshDetail();
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err && err.response && err.response.data ? String(err.response.data) : '';
                    // المنع بسبب مجموعة سابقة غير معتمدة → عرض خيار الفتح الاستثنائي بسبب إلزامي
                    if (!exceptionalReason && msg.indexOf('استثنائي') !== -1) {
                        this.$prompt(msg + '\nأدخل سبب الفتح الاستثنائي:', 'فتح استثنائي', {
                            confirmButtonText: 'فتح استثنائياً',
                            cancelButtonText: 'تراجع',
                            inputType: 'textarea',
                            inputValidator: (v) => (v && v.trim() ? true : 'السبب إلزامي للفتح الاستثنائي'),
                        }).then(({ value }) => {
                            this.callOpenGroup(group, value.trim());
                        }).catch(() => { });
                        return;
                    }
                    this.apiError(err, 'تعذّر فتح المجموعة.');
                });
        },

        openApproveDialog(group) {
            this.approveForm = { groupId: group.id, groupName: group.name, note: '' };
            this.approveDialog = true;
        },

        submitApproveForm() {
            this.$blockUI.Start();
            this.$http.ApproveInventoryCountPeriodGroup(this.approveForm.groupId, { Note: this.approveForm.note || null })
                .then((res) => {
                    this.$blockUI.Stop();
                    this.approveDialog = false;
                    this.$helper.ShowMessage('success', 'تم الاعتماد', (res.data && res.data.message) || 'تم اعتماد المجموعة.');
                    this.refreshDetail();
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.apiError(err, 'تعذّر اعتماد المجموعة.');
                });
        },
    },
};
